import {
  Badge,
  Box,
  Button,
  Chip,
  Paper,
  TextField,
  Tooltip,
  Typography,
  MenuItem,
  IconButton,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  FormControlLabel
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Facebook,
  Instagram,
  WhatsApp,
  PersonOutline,
  EventNote,
  AccessTime,
  ChatBubbleOutline,
  CheckCircleOutline,
  ListAlt,
  Pause,
  EditOutlined,
  MoreVert,
  Archive,
  DeleteOutline,
  FilterList,
  ChevronLeft,
  ChevronRight,
} from "@material-ui/icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// removed legacy quick-create dialog imports
import { endOfDay, format, isSameDay, parse, parseISO } from "date-fns";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Can } from "../../components/Can";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import TicketDetailsModal from "../../components/TicketDetailsModal";
import { listCategories, updateWorkflowState } from "../../services/ticketExtras";
import TagModal from "../../components/TagModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import NewTicketModal from "../../components/NewTicketModal";
import useCompanySettings from "../../hooks/useSettings/companySettings";

// Helper para converter hex/rgb para rgba com alpha
const toRGBA = (color, alpha = 0.08) => {
  try {
    if (!color) return `rgba(0,0,0,${alpha})`;
    if (color.startsWith('rgba')) return color;
    if (color.startsWith('rgb')) {
      const nums = color.replace(/rgba?\(|\)|\s/g, '').split(',').slice(0, 3).map(Number);
      const [r, g, b] = nums;
      return `rgba(${r||0}, ${g||0}, ${b||0}, ${alpha})`;
    }
    // hex #rrggbb ou #rgb
    let hex = color.replace('#','');
    if (hex.length === 3) hex = hex.split('').map(ch => ch+ch).join('');
    const int = parseInt(hex, 16);
    if (Number.isNaN(int)) return `rgba(0,0,0,${alpha})`;
    const r = (int >> 16) & 255;
    const g = (int >> 8) & 255;
    const b = int & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  } catch {
    return `rgba(0,0,0,${alpha})`;
  }
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(1),
    marginTop: 0,
    // Ocupa a viewport desconsiderando a AppBar (64px desktop, 56px mobile)
    height: "calc(100vh - 64px)",
    [theme.breakpoints.down("xs")]: {
      height: "calc(100vh - 56px)",
    },
    width: "100%",
    minHeight: 0,
    overflow: "hidden",
  },
  board: {
    display: "flex",
    gap: theme.spacing(2),
    alignItems: "flex-start",
    overflowX: "auto",
    overflowY: "hidden",
    width: "100%",
    flex: 1,
    height: "100%",
    minHeight: 0,
    paddingBottom: theme.spacing(1),
  },
  boardRow: {
    display: "flex",
    alignItems: "stretch",
    gap: theme.spacing(2),
    width: "100%",
    height: "100%",
    overflow: "hidden",
  },
  sidebar: {
  width: 280,
  minWidth: 280,
    flexShrink: 0,
    height: "100%",
    background: theme.palette.background.paper,
    borderRadius: 8,
  padding: theme.spacing(2),
    overflowY: "auto",
  transition: "width 180ms ease, min-width 180ms ease, padding 180ms ease",
  },
  sidebarPaper: {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
  },
  sidebarShell: {
    height: "100%",
    flexShrink: 0,
    display: "flex",
    alignItems: "stretch",
    overflow: "hidden",
    transition: "width 180ms ease, min-width 180ms ease",
  },
  sidebarShellOpen: {
    width: 280,
    minWidth: 280,
  },
  sidebarShellClosed: {
    width: 56,
    minWidth: 56,
  },
  sidebarCollapsed: {
  width: 56,
  minWidth: 56,
  padding: theme.spacing(1),
    overflow: "hidden",
    '& $sidebarHeader': {
      justifyContent: "center",
    },
  },
  sidebarButtonOnly: {
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: theme.spacing(1),
    background: "transparent",
  },
  sidebarButtonFilled: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    boxShadow: theme.shadows[2],
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      boxShadow: theme.shadows[4],
    },
  },
  sidebarHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
  },
  topBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: theme.spacing(2),
    width: "100%",
    maxWidth: 1200,
  },
  lane: {
    width: 320,
    minWidth: 320,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    overflow: "hidden",
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  laneHeader: {
    padding: theme.spacing(1.5),
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  },
  laneTitle: {
  fontWeight: 700,
  textAlign: "center",
  },
  laneBody: {
  padding: theme.spacing(1.5),
  flex: 1,
  overflowY: "auto",
  minHeight: 0,
  },
  connectionTag: {
    background: "green",
    color: "#FFF",
    marginRight: 1,
    padding: 1,
    fontWeight: "bold",
    borderRadius: 3,
    fontSize: "0.6em",
  },
  lastMessageTime: {
    justifySelf: "flex-end",
    textAlign: "right",
    position: "relative",
    marginLeft: "auto",
    color: theme.palette.text.secondary,
  },
  lastMessageTimeUnread: {
    justifySelf: "flex-end",
    textAlign: "right",
    position: "relative",
    color: theme.palette.success.main,
    fontWeight: "bold",
    marginLeft: "auto",
  },
  cardButton: {
    marginRight: theme.spacing(1),
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  card: {
    borderRadius: 12,
    background: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
      ? 'rgba(38,38,38,0.9)'
      : 'rgba(255,255,255,0.94)',
    border: '1px solid',
    borderColor: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
      ? 'rgba(255,255,255,0.08)'
      : 'rgba(0,0,0,0.08)',
    boxShadow: theme.shadows[0],
    marginBottom: theme.spacing(1),
    cursor: 'grab',
    transition: 'box-shadow 120ms ease, transform 120ms ease, background 160ms ease',
    overflow: 'hidden',
    backfaceVisibility: 'hidden',
    transform: 'translateZ(0)',
    '&:hover': {
      boxShadow: theme.shadows[3],
      transform: 'translateY(-2px) translateZ(0)',
      background: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
        ? 'rgba(48,48,48,0.92)'
        : 'rgba(255,255,255,0.98)'
    },
  },
  cardHeaderBar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
  },
  cardBody: {
    padding: theme.spacing(1),
  },
  headerSection: {
    paddingBottom: theme.spacing(1),
  },
  descriptionSection: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    // Removido divisor superior
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(0.5),
  },
  badgeRow: {
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: "wrap",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  statusRow: {
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: "wrap",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  cardTitleText: {
    fontWeight: 700,
  },
  cardTitle: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    fontWeight: 600,
  },
  cardDesc: {
    fontSize: "0.9rem",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  display: "-webkit-box",
  WebkitLineClamp: 4,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  wordBreak: "break-word",
  },
  ticketNumber: {
    color: theme.palette.text.secondary,
  marginBottom: 0,
  },
  ticketNumberRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  timeInline: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
  },
  contactStrip: {
  display: "inline-flex",
  marginBottom: theme.spacing(1),
  marginTop: theme.spacing(1),
  },
  metaRow: {
    display: "flex",
    gap: theme.spacing(2),
    flexWrap: "wrap",
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
    marginTop: theme.spacing(1),
  },
  overdueLine: {
    color: theme.palette.error.main,
  },
  afterDueText: {
    color: (theme.palette.warning && theme.palette.warning.main) || '#fb8c00',
    fontWeight: 500,
  },
  actionsBar: {
    background: "transparent",
    paddingTop: theme.spacing(1),
    display: "flex",
    gap: theme.spacing(1),
    justifyContent: "space-between",
  },
  cardFooter: {
    // Grid evita gaps de subpixel entre os 3 blocos coloridos
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 0,
    alignItems: "stretch",
    // sem divisores e sem margem para encostar nas bordas do card
    marginTop: 0,
    borderTop: "none",
    // Garante que as cores preencham sem linhas nos cantos
    overflow: "hidden",
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
  },
  footerAction: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(1),
    cursor: "pointer",
    transition: "background 120ms ease",
    // Evita qualquer contorno/borda no foco/hover que possa parecer linha
    outline: "none",
    border: 0,
    margin: 0,
    minWidth: 0,
    WebkitTapHighlightColor: "transparent",
  },
  footerActionPrimary: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    "&:hover": { background: theme.palette.primary.dark },
  },
  footerActionSecondary: {
    background: theme.palette.secondary.main,
    color: theme.palette.common.white,
    "&:hover": { background: theme.palette.secondary.dark },
  },
  footerActionNeutral: {
    background: (theme.palette.type === 'dark' || theme.palette.mode === 'dark') ? theme.palette.grey[800] : theme.palette.grey[700],
    color: theme.palette.common.white,
    '&:hover': { background: (theme.palette.type === 'dark' || theme.palette.mode === 'dark') ? theme.palette.grey[700] : theme.palette.grey[800] },
  },
  dateInput: {
    marginRight: theme.spacing(2),
  },
  chipSquare: {
    borderRadius: 8,
  },
  // Indicador de tipo de ticket (oficial/sessão)
  statusDot: {
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: '50%',
    marginRight: 6,
    boxShadow: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
      ? '0 0 0 1px rgba(255,255,255,0.3)'
      : '0 0 0 1px rgba(0,0,0,0.2)'
  },
  // statusDotOfficial/statusDotSession removidos (não exibiremos mais o indicador)
  // Panel estilo do modal (paper com legenda flutuante)
  panelPaper: {
    padding: theme.spacing(1.5),
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    background: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
      ? 'rgba(0,0,0,0.25)'
      : '#FFFFFF',
    position: 'relative'
  },
  panelLegend: {
    position: 'absolute',
    top: -10,
    left: 12,
    padding: '0 6px',
    fontSize: '0.75rem',
    lineHeight: 1,
    color: theme.palette.text.secondary,
    background: (theme.palette.type === 'dark' || theme.palette.mode === 'dark')
      ? 'rgba(0,0,0,0.25)'
      : '#FFFFFF',
    pointerEvents: 'none'
  },
}));

const Kanban = () => {
  const classes = useStyles();
  const history = useHistory();
  const { user, socket } = useContext(AuthContext);
  const { get: getCompanySetting, getAll: getAllCompanySettings, update: updateCompanySettingApi } = useCompanySettings();
  // Flag avançada do plano (estado com fallback do usuário)
  const [planAdvanced, setPlanAdvanced] = useState(
    user?.company?.plan?.useKanbanAdvanced || user?.plan?.useKanbanAdvanced || user?.useKanbanAdvanced || false
  );
  const [tags, setTags] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [startDate, setStartDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [endDate, setEndDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [currentTicketId, setCurrentTicketId] = useState(null);
  const location = useLocation();
  const [categories, setCategories] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState(() => {
    try { return localStorage.getItem("kanban.categoryFilter") || "all"; } catch { return "all"; }
  });
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    try { return (localStorage.getItem("kanban.sidebarOpen") || "false") === "true"; } catch { return false; }
  });
  const [confirmGreeting, setConfirmGreeting] = useState({ open: false, ticketId: null, targetLaneId: null, message: "" });
  const [manualTicketCreationEnabled, setManualTicketCreationEnabled] = useState(false);
  const [settingsLoaded, setSettingsLoaded] = useState(false);
  // Filtros avançados
  const [contactSearch, setContactSearch] = useState("");
  const [contactOptions, setContactOptions] = useState([]);
  const [contactLoading, setContactLoading] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [usersOptions, setUsersOptions] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showAll, setShowAll] = useState(() => {
    try { return (localStorage.getItem("kanban.showAll") || "false") === "true"; } catch { return false; }
  });
  // Sequenciador para evitar aplicar respostas antigas após alternar showAll
  const fetchSeqRef = useRef(0);
  // SLA modal state
  const [slaModalOpen, setSlaModalOpen] = useState(false);
  const [slaLoading, setSlaLoading] = useState(false);
  const [slaDefaultMinutes, setSlaDefaultMinutes] = useState(0);
  const [slaWarnMinutes, setSlaWarnMinutes] = useState(30);
  const [slaAutoDueDate, setSlaAutoDueDate] = useState(false);
  const [slaNotifications, setSlaNotifications] = useState(true);

  // Tick de atualização para tempos relativos (atualiza a UI a cada 60s)
  const [nowTick, setNowTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setNowTick((t) => t + 1), 60000);
    return () => clearInterval(id);
  }, []);

  const updateCompanySetting = async (key, value) => {
    return updateCompanySettingApi({ column: key, data: value });
  };

  const openSlaModal = async () => {
    try {
      setSlaLoading(true);
      const settings = await getAllCompanySettings(user.companyId);
      setSlaDefaultMinutes(Number(settings?.slaDefaultMinutes || 0));
      setSlaWarnMinutes(Number(settings?.slaWarnMinutes ?? 30));
      setSlaAutoDueDate(String(settings?.slaAutoDueDate || "disabled") === "enabled");
      setSlaNotifications(String(settings?.slaNotifications || "enabled") === "enabled");
      setSlaModalOpen(true);
    } catch (e) {
      toast.error("Falha ao carregar configurações de SLA");
    } finally {
      setSlaLoading(false);
    }
  };
  useEffect(() => {
    try { localStorage.setItem("kanban.sidebarOpen", String(sidebarOpen)); } catch {}
  }, [sidebarOpen]);

  // Carrega flag de criação manual da empresa
  useEffect(() => {
    let mounted = true;
    const fetchFlag = async () => {
      try {
        const setting = await getCompanySetting({ column: "manualTicketCreation" });
        if (!mounted) return;
        setManualTicketCreationEnabled(setting?.manualTicketCreation === "enabled");
        setSettingsLoaded(true);
      } catch (e) {
        // fallback: mantém false silenciosamente
        setManualTicketCreationEnabled(false);
        setSettingsLoaded(true);
      }
    };
    if (user?.companyId) fetchFlag();
    return () => { mounted = false; };
  }, [user?.companyId, getCompanySetting]);

  // Assina eventos em tempo real de settings e plano
  useEffect(() => {
    const companyId = user?.companyId;
    if (!companyId || !socket) return;

    const onCompanySettings = (data) => {
      if (data?.action !== "update") return;
      const key = data?.setting?.key;
      const value = data?.setting?.value;
      if (key === "manualTicketCreation") {
        setManualTicketCreationEnabled(value === "enabled");
        setSettingsLoaded(true);
      }
    };

    const onPlan = (data) => {
      if (data?.action !== "update") return;
      const useAdv = Boolean(data?.plan?.useKanbanAdvanced);
      setPlanAdvanced(useAdv);
    };

    const chSettings = `company-${companyId}-companySettings`;
    const chPlan = `company-${companyId}-plan`;
    socket.on(chSettings, onCompanySettings);
    socket.on(chPlan, onPlan);

    return () => {
      socket.off(chSettings, onCompanySettings);
      socket.off(chPlan, onPlan);
    };
  }, [socket, user?.companyId]);
  // Lane (tag) menu handlers
  const openLaneMenu = (event, lane) => {
    if (!lane || lane.id === "lane0" || lane.id === DONE_LANE_ID || lane.id === ARCHIVED_LANE_ID) return;
    setLaneMenuAnchorEl(event.currentTarget);
    setLaneMenuLane(lane);
  };
  const closeLaneMenu = () => {
    setLaneMenuAnchorEl(null);
    setLaneMenuLane(null);
  };
  const handleEditLane = () => {
    if (!laneMenuLane) return;
    setTagModalTagId(Number(laneMenuLane.id));
    setTagModalOpen(true);
    closeLaneMenu();
  };
  const handleCreateLane = () => {
    setTagModalTagId(null);
    setTagModalOpen(true);
  };
  const handleCloseTagModal = () => {
    setTagModalOpen(false);
    setTagModalTagId(null);
    fetchTags();
  };
  const handleConfirmDeleteLane = () => {
    setConfirmLaneOpen(true);
  };
  // Utilitário: troca duas posições no array e retorna uma nova cópia
  const swapByIndex = (arr, i, j) => {
    if (i === j || i < 0 || j < 0 || i >= arr.length || j >= arr.length) return arr;
    const copy = [...arr];
    const tmp = copy[i];
    copy[i] = copy[j];
    copy[j] = tmp;
    return copy;
  };
  // Persiste a troca de ordem entre dois índices do array de tags/lanes com normalização completa
  const persistSwapOrder = async (i, j) => {
    try {
      if (i === j || i < 0 || j < 0 || i >= tags.length || j >= tags.length) return;
      // 1) Troca local
      const swapped = swapByIndex(tags, i, j);
      // 2) Normaliza a ordem (1..N) garantindo unicidade e sem nulos
      const normalized = swapped.map((t, idx) => ({ ...t, kanbanOrder: idx + 1 }));
      setTags(normalized);
      // 3) Persiste todas as alterações de ordem (somente quando mudou)
      const updates = normalized.map((t, idx) => ({ id: t.id, kanbanOrder: idx + 1 }));
      await Promise.all(updates.map(u => api.put(`/tags/${u.id}`, { kanbanOrder: u.kanbanOrder })));
      // 4) Refaz o carregamento para sincronizar com backend/socket
      fetchTags();
    } catch (err) {
      console.log(err);
      toast.error("Não foi possível reordenar a coluna");
    }
  };
  const handleMoveLaneLeft = async () => {
    if (!laneMenuLane) return;
    const idx = tags.findIndex((t) => String(t.id) === String(laneMenuLane.id));
    if (idx <= 0) return; // já é a primeira
    await persistSwapOrder(idx, idx - 1);
    closeLaneMenu();
  };
  const handleMoveLaneRight = async () => {
    if (!laneMenuLane) return;
    const idx = tags.findIndex((t) => String(t.id) === String(laneMenuLane.id));
    if (idx < 0 || idx >= tags.length - 1) return; // já é a última
    await persistSwapOrder(idx, idx + 1);
    closeLaneMenu();
  };
  const handleDeleteLane = async () => {
    try {
      if (!laneMenuLane) return;
      await api.delete(`/tags/${laneMenuLane.id}`);
      toast.success(i18n.t("tagsKanban.toasts.deleted"));
      setConfirmLaneOpen(false);
      closeLaneMenu();
      fetchTags();
    } catch (err) {
      console.log(err);
      toast.error("Erro ao excluir lane");
      setConfirmLaneOpen(false);
    }
  };
  const categoryById = useMemo(() => {
    const map = new Map();
    (categories || []).forEach(c => map.set(String(c.id), c));
    return map;
  }, [categories]);

  const jsonString = user.queues.map((queue) => queue.UserQueue.queueId);

  useEffect(() => {
    fetchTags();
  }, [user]);

  useEffect(() => {
    // tenta carregar categorias para filtro (ignora erro se feature flag desabilitada)
    (async () => {
      try {
        const { data } = await listCategories();
        setCategories(Array.isArray(data) ? data : (data.items || []));
      } catch {}
    })();
  }, []);

  // Carrega usuários para filtro (uma vez)
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setUsersLoading(true);
        const { data } = await api.get("/users");
        const list = (data && (data.users || (Array.isArray(data) ? data : []))) || [];
        if (mounted) setUsersOptions(list);
      } catch {
        if (mounted) setUsersOptions([]);
      } finally {
        if (mounted) setUsersLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  // Busca contatos (debounced) quando digitado no filtro; ignora grupos
  useEffect(() => {
    const term = (contactSearch || "").trim();
    if (!sidebarOpen) return; // só busca se sidebar aberta
    if (term.length < 3) { setContactOptions([]); setContactLoading(false); return; }
    setContactLoading(true);
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get("/contacts", { params: { searchParam: term } });
        const list = (data?.contacts || []).filter(c => !c.isGroup);
        setContactOptions(list);
      } catch {
        setContactOptions([]);
      } finally {
        setContactLoading(false);
      }
    }, 350);
    return () => clearTimeout(t);
  }, [contactSearch, sidebarOpen]);

  const fetchTags = async () => {
    try {
      const response = await api.get("/tag/kanban/");
      const fetchedTags = response.data.lista || [];
      // Ordena localmente por kanbanOrder ASC (nulos ao fim) e depois por id ASC
      const sorted = [...fetchedTags].sort((a, b) => {
        const ao = a.kanbanOrder;
        const bo = b.kanbanOrder;
        const aNull = ao === null || ao === undefined;
        const bNull = bo === null || bo === undefined;
        if (aNull && bNull) return (a.id || 0) - (b.id || 0);
        if (aNull) return 1;
        if (bNull) return -1;
        if (ao !== bo) return ao - bo;
        return (a.id || 0) - (b.id || 0);
      });
      setTags(sorted);
      fetchTickets();
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTickets = async () => {
    const seq = ++fetchSeqRef.current;
    try {
      const { data } = await api.get("/ticket/kanban", {
        params: {
          queueIds: JSON.stringify(jsonString),
          startDate: startDate,
          endDate: endDate,
          showAll: showAll ? "true" : undefined,
        },
      });
      if (seq === fetchSeqRef.current) {
        setTickets(data.tickets);
      }
    } catch (err) {
      console.log(err);
      if (seq === fetchSeqRef.current) {
        setTickets([]);
      }
    }
  };

  // Recarrega automaticamente ao mudar período (evita botão Buscar)
  useEffect(() => {
    let t = setTimeout(() => { fetchTickets(); }, 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  useEffect(() => {
    const companyId = user.companyId;
    const onAppMessage = (data) => {
      if (
        data.action === "create" ||
        data.action === "update" ||
        data.action === "delete"
      ) {
        fetchTickets();
      }
    };
    socket.on(`company-${companyId}-ticket`, onAppMessage);
    socket.on(`company-${companyId}-appMessage`, onAppMessage);

    return () => {
      socket.off(`company-${companyId}-ticket`, onAppMessage);
      socket.off(`company-${companyId}-appMessage`, onAppMessage);
    };
  }, [socket, user.companyId, startDate, endDate, showAll]);

  // Assina eventos de SLA para alertas visuais e atualização
  useEffect(() => {
    const companyId = user?.companyId;
    if (!companyId || !socket) return;

    const onSla = () => {
      fetchTickets();
    };

    const channel = `company-${companyId}-sla`;
    socket.on(channel, onSla);
    return () => {
      socket.off(channel, onSla);
    };
  }, [socket, user?.companyId, showAll]);
  // Assinatura para eventos de TAG (criação/edição/remoção) e refresh das colunas
  useEffect(() => {
    const companyId = user.companyId;
    const onTagMessage = () => {
      fetchTags();
    };
    // Canais possíveis (variações usadas no backend)
    const ch1 = `company-${companyId}-tag`;
    const ch2 = `company${companyId}-tag`;

    socket.on(ch1, onTagMessage);
    socket.on(ch2, onTagMessage);

    return () => {
      socket.off(ch1, onTagMessage);
      socket.off(ch2, onTagMessage);
    };
  }, [socket, user.companyId, showAll]);

  useEffect(() => {
    const companyId = user.companyId;
    const refresh = () => fetchTickets();
    const ch1 = `company-${companyId}-ticket-details`;
    const ch2 = `company-${companyId}-ticket-assignees`;
    const ch3 = `company-${companyId}-ticket-comment`;
    const ch4 = `company-${companyId}-ticket-checklist`;

    socket.on(ch1, refresh);
    socket.on(ch2, refresh);
    socket.on(ch3, refresh);
    socket.on(ch4, refresh);

    return () => {
      socket.off(ch1, refresh);
      socket.off(ch2, refresh);
      socket.off(ch3, refresh);
      socket.off(ch4, refresh);
    };
  }, [socket, user.companyId, startDate, endDate, showAll]);

  // Refetch imediato quando showAll muda para garantir que a lista reflita a seleção atual
  useEffect(() => {
    fetchTickets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAll]);

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  // Habilitação consolidada do recurso "Tickets Avançados"
  const advancedTicketsEnabled = useMemo(
    () => Boolean(planAdvanced) && (settingsLoaded ? Boolean(manualTicketCreationEnabled) : false),
    [planAdvanced, manualTicketCreationEnabled, settingsLoaded]
  );

  const IconChannel = (channel) => {
    switch (channel) {
      case "facebook":
        return (
          <Facebook
            style={{
              color: "#3b5998",
              verticalAlign: "middle",
              fontSize: "16px",
            }}
          />
        );
      case "instagram":
        return (
          <Instagram
            style={{
              color: "#e1306c",
              verticalAlign: "middle",
              fontSize: "16px",
            }}
          />
        );
      case "whatsapp":
        return (
          <WhatsApp
            style={{
              color: "#25d366",
              verticalAlign: "middle",
              fontSize: "16px",
            }}
          />
        );
      default:
        return "error";
    }
  };
  const handleCardClick = (uuid) => history.push("/tickets/" + uuid);

  const getDueMeta = (ticket) => {
    const raw = ticket?.slaDueAt || ticket?.dueDate;
    if (!raw) return null;
    try {
      let hasTime = false;
      let d;
      if (typeof raw === "string") {
        // Detecta presença de hora no texto ISO
        hasTime = /T\d{2}:\d{2}/.test(raw);
        d = hasTime ? parseISO(raw) : parse((raw.match(/^\d{4}-\d{2}-\d{2}/)?.[0] || raw), "yyyy-MM-dd", new Date());
      } else {
        d = new Date(raw);
        // Se veio objeto Date, assumimos que pode ter hora
        hasTime = true;
      }
      if (!d || isNaN(d.getTime())) return null;
      const isPaused = Boolean(ticket?.slaPaused || ticket?.support?.sla_pausado);
      let overdue = false;
      if (typeof ticket?.slaRemainingMs === "number") {
        overdue = ticket.slaRemainingMs <= 0 && !isPaused;
      } else {
        // Fallback: se tiver hora, compara direto; senão, fim do dia
        overdue = (hasTime ? d.getTime() : endOfDay(d).getTime()) < Date.now();
      }
      const fmt = hasTime ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy";
      const txt = format(d, fmt);
      const text = overdue ? `${txt} (atrasado)` : txt;
      return { text, overdue };
    } catch {
      return null;
    }
  };

  // Quando concluído/arquivado, exibir linha de conclusão e se foi antes/após o vencimento
  const getCompletionMeta = (ticket) => {
    try {
      const state = ticket?.workflowState;
      if (state !== 'done' && state !== 'archived') return null;
      const completedRaw = ticket?.concludedAt || ticket?.archivedAt;
      if (!completedRaw) return null;
      const completed = typeof completedRaw === 'string' ? parseISO(completedRaw) : new Date(completedRaw);
      if (!completed || isNaN(completed.getTime())) return null;

      // Determinar o prazo de corte
      const raw = ticket?.slaDueAt || ticket?.dueDate;
      let cutoff = null;
      if (raw) {
        let hasTime = false;
        let d;
        if (typeof raw === 'string') {
          hasTime = /T\d{2}:\d{2}/.test(raw);
          d = hasTime ? parseISO(raw) : parse((raw.match(/^\d{4}-\d{2}-\d{2}/)?.[0] || raw), "yyyy-MM-dd", new Date());
        } else {
          d = new Date(raw);
          hasTime = true;
        }
        if (d && !isNaN(d.getTime())) {
          cutoff = hasTime ? d : endOfDay(d);
        }
      }

      const label = state === 'done' ? 'Concluído' : 'Arquivado';
      const when = format(completed, 'dd/MM/yyyy HH:mm');
      let suffix = '';
      if (cutoff) {
        suffix = completed.getTime() <= cutoff.getTime() ? 'antes do vencimento' : 'após o vencimento';
      }
      return { label, when, suffix };
    } catch {
      return null;
    }
  };

  const formatActiveDuration = (ms) => {
    try {
      if (!ms || ms <= 0) return "0m";
      const totalMinutes = Math.floor(ms / 60000);
      if (totalMinutes < 60) return `${totalMinutes}m`;
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      if (hours < 24) return minutes ? `${hours}h ${minutes}m` : `${hours}h`;
      const days = Math.floor(hours / 24);
      const remHours = hours % 24;
      return remHours ? `${days}d ${remHours}h` : `${days}d`;
    } catch { return "--"; }
  };

  // Fallback: calcular duração aberta desde a criação quando activeDurationMs não refletir corretamente
  const getOpenDurationMs = (t) => {
    try {
      const start = t?.createdAt ? new Date(t.createdAt).getTime() : null;
      const end = (t?.concludedAt || t?.archivedAt)
        ? new Date(t.concludedAt || t.archivedAt).getTime()
        : Date.now();
      if (!start || !end) return null;
      // Sempre contar tempo aberto pelo relógio (ignora pausas de SLA para exibição)
      return Math.max(0, end - start);
    } catch { return null; }
  };

  // ALTERAÇÃO: Definição de constantes para lanes de workflow
const DONE_LANE_ID = "__DONE__";
const ARCHIVED_LANE_ID = "__ARCHIVED__";

  // SUBSTITUIR a definição existente de const lanes = useMemo(...)
  // NOVA IMPLEMENTAÇÃO ABAIXO
  const lanes = useMemo(() => {
    // Separa por estado para facilitar
    const activeTickets = tickets.filter(t => (t.workflowState || 'active') === 'active');
    const doneTickets = tickets.filter(t => t.workflowState === 'done');
    const archivedTickets = tickets.filter(t => t.workflowState === 'archived');
    let filtered = categoryFilter === 'all' ? activeTickets : activeTickets.filter((t) => String(t.categoryId || '') === String(categoryFilter));
    if (selectedContact && selectedContact.id) {
      filtered = filtered.filter((t) => String(t?.contact?.id || '') === String(selectedContact.id));
    }
    if (selectedUser && selectedUser.id) {
      filtered = filtered.filter((t) => String(t?.userId || '') === String(selectedUser.id));
    }
    const untagged = filtered.filter((t) => (t.tags || []).length === 0);
    const dynamicLanes = [
      { id: 'lane0', title: i18n.t('tagsKanban.laneDefault'), color: '#9e9e9e', items: untagged },
      ...tags.map(tag => ({
        id: String(tag.id),
        title: tag.name,
        color: tag.color,
        items: filtered.filter(t => (t.tags || []).some(tg => tg.id === tag.id))
      }))
    ];
    // Lanes fixas de workflow no final
    dynamicLanes.push({ id: DONE_LANE_ID, title: 'Concluídos', color: '#2e7d32', items: doneTickets });
    dynamicLanes.push({ id: ARCHIVED_LANE_ID, title: 'Arquivados', color: '#616161', items: archivedTickets });
    return dynamicLanes;
  }, [tags, tickets, categoryFilter, selectedContact, selectedUser, i18n]);

  // SUBSTITUIR função onDragEnd existente pela nova abaixo
  const onDragEnd = async (result) => {
    const { destination, source, draggableId } = result || {};
    if (!destination) return;
    const sourceLaneId = source.droppableId;
    const targetLaneId = destination.droppableId;
    if (sourceLaneId === targetLaneId) return;
    const ticketId = draggableId;
    // Identificar ticket origem
    const ticket = tickets.find(t => String(t.id) === String(ticketId));
    if (!ticket) return;
    const currentState = ticket.workflowState || 'active';
    try {
      // Bloqueio global: concluir/arquivar via Kanban exige Tickets Avançados habilitado
      if (!advancedTicketsEnabled && (targetLaneId === DONE_LANE_ID || targetLaneId === ARCHIVED_LANE_ID)) {
        toast.info("Ative 'Tickets Avançados' para concluir/arquivar pelo Kanban.");
        return;
      }
      // A permissão de concluir/arquivar depende apenas do Kanban Avançado
      // Movimento para lanes fixas
      if (targetLaneId === DONE_LANE_ID) {
        if (currentState !== 'done') {
          await updateWorkflowState(ticketId, 'done');
          toast.success('Ticket concluído');
        }
        return fetchTickets();
      }
      if (targetLaneId === ARCHIVED_LANE_ID) {
        if (currentState !== 'archived') {
          await updateWorkflowState(ticketId, 'archived');
          toast.success('Ticket arquivado');
        }
        return fetchTickets();
      }
      // Saindo de done/archived para voltar a ativo
      const restoringToActive = [DONE_LANE_ID, ARCHIVED_LANE_ID].includes(sourceLaneId) && targetLaneId !== DONE_LANE_ID && targetLaneId !== ARCHIVED_LANE_ID;
      if (restoringToActive) {
        // Bloqueio global: restauração exige Tickets Avançados habilitado
        if (!advancedTicketsEnabled) {
          toast.info("Ative 'Tickets Avançados' para restaurar tickets pelo Kanban.");
          return;
        }
        if (currentState !== 'active') {
          await updateWorkflowState(ticketId, 'active');
        }
        // Se destino é lane0 remove tags, senão atribui tag
        if (targetLaneId === 'lane0') {
          await api.delete(`/ticket-tags/${ticketId}`);
        } else {
          // Atribuir tag destino (sem greeting para restauração)
          await api.delete(`/ticket-tags/${ticketId}`);
          await api.put(`/ticket-tags/${ticketId}/${targetLaneId}`);
        }
        toast.success('Ticket restaurado');
        return fetchTickets();
      }
      // Movimento entre lanes ativas (tags / lane0)
      if (currentState === 'active' && targetLaneId !== DONE_LANE_ID && targetLaneId !== ARCHIVED_LANE_ID) {
        if (targetLaneId !== 'lane0') {
          const laneCfg = tags.find(t => String(t.id) === String(targetLaneId));
          const hasGreeting = laneCfg && laneCfg.greetingMessageLane && String(laneCfg.greetingMessageLane).trim() !== '';
          if (laneCfg && laneCfg.manualGreetingMode === 'prompt' && hasGreeting) {
            setConfirmGreeting({ open: true, ticketId, targetLaneId, message: laneCfg.greetingMessageLane });
            return;
          }
          let payload = undefined;
          if (laneCfg && laneCfg.manualGreetingMode === 'auto' && hasGreeting) {
            payload = { sendGreeting: true };
          }
          await api.delete(`/ticket-tags/${ticketId}`);
          await api.put(`/ticket-tags/${ticketId}/${targetLaneId}`, payload);
          toast.success('Tag atribuída ao ticket');
        } else {
          await api.delete(`/ticket-tags/${ticketId}`);
          toast.success('Tag removida do ticket');
        }
        return fetchTickets();
      }
      // Movimento de active para done/archived já tratado acima
    } catch (e) {
      console.log(e);
      toast.error('Falha ao mover ticket');
    }
  };

  // Handler para confirmação do envio de saudação (modo prompt)
  const handleConfirmGreeting = async (shouldSend) => {
    const { ticketId, targetLaneId } = confirmGreeting;
    setConfirmGreeting({ open: false, ticketId: null, targetLaneId: null, message: "" });
    if (!ticketId || !targetLaneId) return;
    try {
      await api.delete(`/ticket-tags/${ticketId}`);
      const payload = shouldSend ? { sendGreeting: true } : undefined;
      await api.put(`/ticket-tags/${ticketId}/${targetLaneId}`, payload);
      toast.success("Tag atribuída ao ticket");
      await fetchTickets(jsonString);
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddConnectionClick = () => {
  // Abre o modal de Nova Lane diretamente no Kanban
  setTagModalTagId(null);
  setTagModalOpen(true);
  };

  const openDetails = (ticketId) => {
    setCurrentTicketId(ticketId);
    setDetailsOpen(true);
  };

  const closeDetails = () => {
    setDetailsOpen(false);
    setCurrentTicketId(null);
  };

  // Se vier do TicketInfo com state.openTicketId, abrir o modal do ticket ao montar
  useEffect(() => {
    const state = location && location.state;
    const incomingId = state && state.openTicketId ? Number(state.openTicketId) : null;
    if (incomingId) {
      openDetails(incomingId);
      // Limpa o state para evitar reabertura em navegações futuras
  history.replace({ pathname: "/kanban", state: null });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSavedDetails = () => fetchTickets();

  const priorityLabel = (p) => {
    if (p === 2) return "Alta";
    if (p === 0) return "Baixa";
    return "Média";
  };

  const priorityColor = (p) => {
    if (p === 2) return "secondary"; // vermelho
    if (p === 0) return "default"; // neutro
    return "primary"; // médio
  };
  const fmtBRL = (v) => {
    try {
      const n = Number(v);
      if (Number.isNaN(n)) return String(v);
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n);
    } catch {
      return String(v);
    }
  };
  const satisfColor = (s) => {
    const map = {
      bom: "primary",
      neutro: "default",
      ruim: "secondary",
    };
    const key = String((s || "").toLowerCase());
    return map[key] || "default";
  };

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuTicket, setMenuTicket] = useState(null);
  // Lane (tag) management state
  const [laneMenuAnchorEl, setLaneMenuAnchorEl] = useState(null);
  const [laneMenuLane, setLaneMenuLane] = useState(null);
  const [tagModalOpen, setTagModalOpen] = useState(false);
  const [tagModalTagId, setTagModalTagId] = useState(null);
  const [confirmLaneOpen, setConfirmLaneOpen] = useState(false);
  // Criar ticket via modal completo (TicketDetailsModal) partindo do Kanban
  const [createTicketOpen, setCreateTicketOpen] = useState(false);
  const [createdTicketId, setCreatedTicketId] = useState(null);
  // legacy quick-create dialog state removed

  // legacy quick-create contact search effect removed

  const handleOpenMenu = (event, ticket) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuTicket(ticket);
  };
  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
    setMenuTicket(null);
  };

  const handleArchiveTicket = async () => {
  if (!menuTicket) return; 
    try { await updateWorkflowState(menuTicket.id, 'archived'); toast.success('Ticket arquivado'); handleCloseMenu(); fetchTickets(); } catch (e) { toast.error('Erro ao arquivar'); }
  };
  const handleCompleteTicket = async () => {
  if (!menuTicket) return; 
    try { await updateWorkflowState(menuTicket.id, 'done'); toast.success('Ticket concluído'); handleCloseMenu(); fetchTickets(); } catch (e) { toast.error('Erro ao concluir'); }
  };
  const handleRestoreTicket = async () => {
    if (!menuTicket) return; 
    try { await updateWorkflowState(menuTicket.id, 'active'); toast.success('Ticket restaurado'); handleCloseMenu(); fetchTickets(); } catch { toast.error('Erro ao restaurar'); }
  };
  const handleDeleteTicket = async () => {
    if (!menuTicket) return;
    try {
      await api.delete(`/tickets/${menuTicket.id}`);
      toast.success('Ticket excluído');
      handleCloseMenu();
      fetchTickets();
    } catch (e) {
      toast.error('Erro ao excluir');
    }
  };

  // Listener para abrir o modal a partir do NotificationKanban sem mudar de rota
  useEffect(() => {
    const handler = (e) => {
      try {
        const id = e?.detail?.ticketId;
        if (id) openDetails(Number(id));
      } catch {}
    };
    window.addEventListener("open-ticket-modal", handler);
    return () => window.removeEventListener("open-ticket-modal", handler);
  }, []);

  return (
    <div className={classes.root}>
      <DragDropContext onDragEnd={onDragEnd}>
        <div className={classes.boardRow}>
          <div className={`${classes.sidebarShell} ${sidebarOpen ? classes.sidebarShellOpen : classes.sidebarShellClosed}`}>
            {sidebarOpen ? (
        <Paper className={`${classes.sidebar} ${classes.sidebarPaper}`} elevation={2}>
                <div className={classes.sidebarHeader}>
          <Typography variant="subtitle1" color="primary" style={{ fontWeight: 700 }}>Filtros</Typography>
                  <IconButton size="small" color="primary" onClick={() => setSidebarOpen(false)}><FilterList /></IconButton>
                </div>
                {/* Ações (movido para o topo) */}
                <Box mt={0}>
                  <div className={classes.panelPaper}>
                    <Typography variant="caption" className={classes.panelLegend}>Ações</Typography>
                    <Box display="flex" flexDirection="column" gridGap={8} style={{ gap: 8 }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => { if (planAdvanced && (settingsLoaded ? manualTicketCreationEnabled : true)) setCreateTicketOpen(true); }}
                        disabled={!(planAdvanced && (settingsLoaded ? manualTicketCreationEnabled : true))}
                        fullWidth
                      >
                        {"Criar ticket"}
                      </Button>
                      {user?.profile === 'admin' && (
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleAddConnectionClick}
                            fullWidth
                          >
                            {"+ Adicionar colunas"}
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={()=> history.push("/checklists/modelos")}
                            disabled={!(planAdvanced && (settingsLoaded ? manualTicketCreationEnabled : true))}
                          >
                            Modelos de Checklist
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={()=> { if (planAdvanced && (settingsLoaded ? manualTicketCreationEnabled : true)) history.push("/custom-category-fields"); }}
                            disabled={!(planAdvanced && (settingsLoaded ? manualTicketCreationEnabled : true))}
                          >
                            Campos Pers.
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={()=> history.push("/servicos")}
                            disabled={!(planAdvanced && (settingsLoaded ? manualTicketCreationEnabled : true))}
                          >
                            Serviços
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={() => { if (planAdvanced && (settingsLoaded ? manualTicketCreationEnabled : true)) openSlaModal(); }}
                            disabled={!(planAdvanced && (settingsLoaded ? manualTicketCreationEnabled : true))}
                          >
                            SLA
                          </Button>
                        </>
                      )}
                      {(() => {
                        const advancedTicketsWarning = !planAdvanced
                          ? "Recurso do plano Kanban Avançado. Ative no seu plano."
                          : (settingsLoaded && !manualTicketCreationEnabled
                              ? "Ative 'Tickets Avançados' nas Configurações da empresa."
                              : "");
                        return advancedTicketsWarning ? (
                          <Typography variant="caption" style={{ textAlign: 'center', color: '#f44336' }}>
                            {advancedTicketsWarning}
                          </Typography>
                        ) : null;
                      })()}
                    </Box>
                  </div>
                </Box>

                {/* Filtros (compacto) */}
                <Box mt={2}>
                <div className={classes.panelPaper}>
                  <Typography variant="caption" className={classes.panelLegend}>Filtros</Typography>
                  <Box display="grid" gridGap={12} style={{ gap: 12 }}>
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={showAll}
                          onChange={(e) => {
                            const v = e.target.checked;
                            setShowAll(v);
                            try { localStorage.setItem("kanban.showAll", String(v)); } catch {}
                            fetchTickets();
                          }}
                        />
                      }
                      label="Ver tudo"
                    />
                    <TextField
                      select
                      variant="outlined"
                      size="small"
                      label="Categoria"
                      value={categoryFilter}
                      onChange={(e) => {
                        const v = e.target.value;
                        setCategoryFilter(v);
                        try { localStorage.setItem("kanban.categoryFilter", v); } catch {}
                      }}
                      style={{ minWidth: 200, width: "100%" }}
                    >
                      <MenuItem value="all">Todas</MenuItem>
                      {categories.map((c) => (
                        <MenuItem key={c.id} value={String(c.id)}>{c.name}</MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      label="Data de início"
                      type="date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      size="small"
                      fullWidth
                      className={classes.dateInput}
                    />
                    <TextField
                      label="Data de fim"
                      type="date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      size="small"
                      fullWidth
                      className={classes.dateInput}
                    />
                    <Autocomplete
                      options={contactOptions}
                      loading={contactLoading}
                      getOptionLabel={(o) => (o?.name && o?.number) ? `${o.name} - ${o.number}` : (o?.name || o?.number || "")}
                      isOptionEqualToValue={(opt, val) => opt.id === val.id}
                      value={selectedContact}
                      onChange={(e, nv) => setSelectedContact(nv || null)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          size="small"
                          label="Buscar contato"
                          value={contactSearch}
                          onChange={(e) => setContactSearch(e.target.value)}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {contactLoading ? <CircularProgress color="inherit" size={16} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            )
                          }}
                          placeholder="Digite 3+ letras"
                          fullWidth
                        />
                      )}
                    />
                    <Autocomplete
                      options={usersOptions}
                      loading={usersLoading}
                      getOptionLabel={(o) => (o?.name || o?.email || `Usuário ${o?.id || ''}`)}
                      isOptionEqualToValue={(opt, val) => opt.id === val.id}
                      value={selectedUser}
                      onChange={(e, nv) => setSelectedUser(nv || null)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          size="small"
                          label="Selecionar usuário"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {usersLoading ? <CircularProgress color="inherit" size={16} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            )
                          }}
                          fullWidth
                        />
                      )}
                    />
                  </Box>
                </div>
                </Box>

                {/* Ações (removido daqui; movido para o topo) */}
              </Paper>
            ) : (
              <div className={classes.sidebarButtonOnly}>
                <IconButton size="small" className={classes.sidebarButtonFilled} onClick={() => setSidebarOpen(true)}>
                  <FilterList style={{ color: 'inherit' }} />
                </IconButton>
              </div>
            )}
          </div>
          <div className={classes.board}>
          {lanes.map((lane) => (
            <Paper
              key={lane.id}
              className={classes.lane}
              elevation={2}
              style={{ backgroundColor: toRGBA(lane.color || "#424242", 0.06) }}
            >
              <div className={classes.laneHeader} style={{ backgroundColor: lane.color || "#424242" }}>
                <Typography variant="subtitle1" className={classes.laneTitle}>
                  {`${lane.items.length} • ${lane.title}`}
                </Typography>
                {lane.id !== "lane0" && lane.id !== DONE_LANE_ID && lane.id !== ARCHIVED_LANE_ID && (
                  <IconButton
                    size="small"
                    style={{ position: "absolute", right: 4, top: 4, color: "#fff" }}
                    onClick={(e) => openLaneMenu(e, lane)}
                  >
                    <MoreVert />
                  </IconButton>
                )}
              </div>
              <Droppable droppableId={lane.id}>
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className={classes.laneBody}
                    style={{
                      background: snapshot.isDraggingOver
                        ? toRGBA(lane.color || "#424242", 0.12)
                        : toRGBA(lane.color || "#424242", 0.06),
                      minHeight: 40,
                    }}
                  >
                    {lane.items.map((ticket, index) => (
                      <Draggable
                        draggableId={String(ticket.id)}
                        index={index}
                        key={ticket.id}
                      >
                        {(providedDraggable) => (
                          <div
                            ref={providedDraggable.innerRef}
                            {...providedDraggable.draggableProps}
                            {...providedDraggable.dragHandleProps}
                          >
                            <div className={classes.card}>
                              {/* Header colorido (tema) apenas atrás do título */}
                              <div className={classes.cardHeaderBar}>
                                <Typography className={classes.cardHeaderTitle}>
                                  {ticket.subject || ticket.contact?.name}
                                </Typography>
                              </div>

                              <div className={classes.cardBody}>
                                {/* Topo: indicador tipo • Ticket nº • tempo */}
                                <div className={classes.ticketNumberRow}>
                                  <Typography variant="body2" component="span" className={classes.ticketNumber}>{`Ticket nº ${ticket.id}`}</Typography>
                                  <Typography variant="body2" component="span" color="textSecondary">•</Typography>
                                  <Typography variant="body2" component="span" color="textSecondary" className={classes.timeInline}>
                                    <AccessTime style={{ fontSize: 16, opacity: 0.8, verticalAlign: "middle" }} />
                                    {isSameDay(parseISO(ticket.lastEditAt || ticket.updatedAt), new Date())
                                      ? format(parseISO(ticket.lastEditAt || ticket.updatedAt), "HH:mm")
                                      : format(parseISO(ticket.lastEditAt || ticket.updatedAt), "dd/MM/yyyy")}
                                  </Typography>
                                </div>
                                {/* Chip de WorkflowState */}
                                {ticket.workflowState && ticket.workflowState !== 'active' && (
                                  <div className={classes.statusRow} style={{ marginTop: 4 }}>
                                    {ticket.workflowState === 'done' && (
                                      <Chip size="small" className={classes.chipSquare} label="Concluído" style={{ backgroundColor: '#2e7d32', color: '#fff' }} />
                                    )}
                                    {ticket.workflowState === 'archived' && (
                                      <Chip size="small" className={classes.chipSquare} label="Arquivado" style={{ backgroundColor: '#616161', color: '#fff' }} />
                                    )}
                                  </div>
                                )}

                                {/* Criado por + Aberto há */}
                                <div className={classes.metaRow} style={{ marginTop: 4, gap: 8 }}>
                                  <span><PersonOutline style={{ fontSize: 16, verticalAlign: "middle" }} /> Criado por: <strong>{ticket?.creator?.name || ticket?.user?.name || "—"}</strong></span>
                                  {(() => {
                                    // Referenciar nowTick para re-render periódico
                                    void nowTick;
                                    const openMs = getOpenDurationMs(ticket);
                                    if (openMs == null) return null;
                                    const state = ticket?.workflowState || 'active';
                                    const label = (state === 'done' || state === 'archived') ? 'Aberto por:' : 'Aberto há:';
                                    return (
                                      <span>
                                        • {label} <strong>{formatActiveDuration(openMs)}</strong>
                                      </span>
                                    );
                                  })()}
                                </div>

                                {/* Categoria + Serviço + Prioridade (somente com Tickets Avançados) */}
                                {advancedTicketsEnabled && (
                                  <div className={classes.badgeRow}>
                                    {ticket?.categoryId && categoryById.get(String(ticket.categoryId)) && (
                                      <Chip
                                        size="small"
                                        className={classes.chipSquare}
                                        label={categoryById.get(String(ticket.categoryId)).name}
                                        style={{ backgroundColor: categoryById.get(String(ticket.categoryId)).color || "#eceff1", color: "#fff", fontWeight: 400 }}
                                      />
                                    )}
                                    {(() => {
                                      const sName = ticket?.serviceName || ticket?.service?.name;
                                      return sName ? (
                                        <Chip size="small" className={classes.chipSquare} label={sName} />
                                      ) : null;
                                    })()}
                                    <Chip size="small" className={classes.chipSquare} label={`${priorityLabel(ticket?.priority)}`} />
                                  </div>
                                )}

                                {/* Para: Contato */}
                                <div className={classes.contactStrip}>
                                  <Chip
                                    size="small"
                                    className={classes.chipSquare}
                                    color="default"
                                    icon={<PersonOutline />}
                                    label={`Para: ${ticket.contact?.name || ticket.contact?.number || "—"}`}
                                  />
                                </div>

                                {/* Vencimento/Conclusão (somente com Tickets Avançados) */}
                                {advancedTicketsEnabled && (() => {
                                  const state = ticket.workflowState || 'active';
                                  if (state === 'active') {
                                    const dueMeta = getDueMeta(ticket);
                                    if (!dueMeta) return null;
                                    return (
                                      <div className={classes.metaRow}>
                                        <span className={dueMeta.overdue ? classes.overdueLine : undefined}>
                                          <EventNote style={{ fontSize: 16, verticalAlign: "middle" }} /> Vencimento: <strong>{dueMeta.text}</strong>
                                        </span>
                                      </div>
                                    );
                                  }
                                  const comp = getCompletionMeta(ticket);
                                  if (!comp) return null;
                                  return (
                                    <div className={classes.metaRow}>
                                      <span>
                                        <EventNote style={{ fontSize: 16, verticalAlign: "middle" }} /> {comp.label}: <strong>{comp.when}</strong>
                                        {comp.suffix && (
                                          comp.suffix === 'após o vencimento' ? (
                                            <span className={classes.afterDueText}>{` (${comp.suffix})`}</span>
                                          ) : (
                                            <span>{` (${comp.suffix})`}</span>
                                          )
                                        )}
                                      </span>
                                    </div>
                                  );
                                })()}

                                {/* Descrição */}
                                {ticket?.description ? (
                                  <div className={classes.descriptionSection}>
                                    <div className={classes.cardDesc}>{ticket.description}</div>
                                  </div>
                                ) : null}

                                {/* Extras (somente com Tickets Avançados) */}
                                {advancedTicketsEnabled && (() => {
                                  const hasValor = ticket?.support?.valor != null && ticket.support.valor !== "";
                                  const hasEtapa = !!ticket?.support?.etapa;
                                  const hasSat = !!ticket?.support?.satisfacao;
                                  const hasAmb = !!ticket?.support?.ambiente;
                                  if (!(hasValor || hasEtapa || hasSat || hasAmb)) return null;
                                  return (
                                    <div className={classes.badgeRow}>
                                      {hasValor && (<Chip size="small" className={classes.chipSquare} label={fmtBRL(ticket.support.valor)} />)}
                                      {hasEtapa && (<Chip size="small" className={classes.chipSquare} variant="outlined" label={`Etapa: ${ticket.support.etapa}`} />)}
                                      {hasSat && (<Chip size="small" className={classes.chipSquare} label={`Sat: ${ticket.support.satisfacao}`} />)}
                                      {hasAmb && (<Chip size="small" className={classes.chipSquare} variant="outlined" label={`Amb: ${ticket.support.ambiente}`} />)}
                                    </div>
                                  );
                                })()}

                                {/* Status compactos: SLA e flags de suporte (avançado); comentários e checklist (sempre) */}
                                <div className={classes.statusRow}>
                                  {advancedTicketsEnabled && (ticket?.workflowState || 'active') === 'active' && ticket?.slaOverdue && (
                                    <Chip size="small" className={classes.chipSquare} color="secondary" icon={<EventNote style={{ fontSize: 16 }} />} label="SLA vencido" />
                                  )}
                                  {advancedTicketsEnabled && (ticket?.workflowState || 'active') === 'active' && !ticket?.slaOverdue && ticket?.slaWarn && (
                                    <Chip size="small" className={classes.chipSquare} color="primary" icon={<EventNote style={{ fontSize: 16 }} />} label="SLA vencendo" />
                                  )}
                                  {Number(ticket?.commentsCount || 0) > 0 && (
                                    <Chip size="small" className={classes.chipSquare} icon={<ChatBubbleOutline style={{ fontSize: 16 }} />} label={`${Number(ticket.commentsCount)}`} />
                                  )}
                                  {ticket?.checklist && (
                                    <Chip size="small" className={classes.chipSquare} icon={<ListAlt style={{ fontSize: 16 }} />} label={`${ticket.checklist.done || 0}/${ticket.checklist.total || 0}`} />
                                  )}
                                  {advancedTicketsEnabled && ticket?.support?.aguardando && (<Chip size="small" className={classes.chipSquare} icon={<EventNote style={{ fontSize: 16 }} />} label="Aguardando" />)}
                                  {advancedTicketsEnabled && ticket?.support?.em_investigacao && (<Chip size="small" className={classes.chipSquare} icon={<CheckCircleOutline style={{ fontSize: 16 }} />} label="Investigação" />)}
                                  {advancedTicketsEnabled && ticket?.support?.sla_pausado && (<Chip size="small" className={classes.chipSquare} icon={<Pause style={{ fontSize: 16 }} />} label="SLA pausado" color="secondary" />)}
                                </div>
                              </div>
                              
                              {/* Footer com ícones-only, colado às bordas */}
                              <div className={classes.cardFooter}>
                                <div className={`${classes.footerAction} ${classes.footerActionPrimary}`} onClick={() => handleCardClick(ticket.uuid)}>
                                  <Tooltip title="Abrir conversa"><ChatBubbleOutline /></Tooltip>
                                </div>
                                <div className={`${classes.footerAction} ${classes.footerActionSecondary}`} onClick={() => { openDetails(ticket.id); }}>
                                  <Tooltip title="Editar ticket"><EditOutlined /></Tooltip>
                                </div>
                                <div className={`${classes.footerAction} ${classes.footerActionNeutral}`} onClick={(e) => handleOpenMenu(e, ticket)}>
                                  <Tooltip title="Mais opções"><MoreVert /></Tooltip>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </Paper>
          ))}
          </div>
        </div>
      </DragDropContext>

      {/* Menu sanduíche */}
      <Menu
        anchorEl={menuAnchorEl}
        keepMounted
        open={Boolean(menuAnchorEl)}
        onClose={handleCloseMenu}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {(() => {
          if (!menuTicket) return null;
          const state = (menuTicket.workflowState === 'done' || menuTicket.workflowState === 'archived' || menuTicket.workflowState === 'active') ? menuTicket.workflowState : 'active';
          const items = [];
          if (state === 'active') {
            if (advancedTicketsEnabled) {
              items.push(
                <MenuItem key="done" onClick={handleCompleteTicket}>
                  <CheckCircleOutline style={{ fontSize: 18, marginRight: 8 }} /> Concluir
                </MenuItem>
              );
              items.push(
                <MenuItem key="archive" onClick={handleArchiveTicket}>
                  <Archive style={{ fontSize: 18, marginRight: 8 }} /> Arquivar
                </MenuItem>
              );
            }
          } else if (state === 'done') {
            if (advancedTicketsEnabled) {
              items.push(
                <MenuItem key="restore" onClick={handleRestoreTicket}>
                  <MoreVert style={{ fontSize: 18, marginRight: 8 }} /> Restaurar
                </MenuItem>
              );
            }
            if (advancedTicketsEnabled) {
              items.push(
                <MenuItem key="archive" onClick={handleArchiveTicket}>
                  <Archive style={{ fontSize: 18, marginRight: 8 }} /> Arquivar
                </MenuItem>
              );
            }
          } else if (state === 'archived') {
            if (advancedTicketsEnabled) {
              items.push(
                <MenuItem key="restore" onClick={handleRestoreTicket}>
                  <MoreVert style={{ fontSize: 18, marginRight: 8 }} /> Restaurar
                </MenuItem>
              );
            }
          }
          items.push(
            <MenuItem key="delete" onClick={handleDeleteTicket}>
              <DeleteOutline style={{ fontSize: 18, marginRight: 8 }} /> Excluir
            </MenuItem>
          );
          return items;
        })()}
      </Menu>

      <TicketDetailsModal open={detailsOpen} onClose={closeDetails} ticketId={currentTicketId} onSaved={onSavedDetails} />

      {/* Criação de ticket oficial a partir do Kanban usando modal completo */}
      {createTicketOpen && (
        <TicketDetailsModal
          open={createTicketOpen}
          onClose={() => setCreateTicketOpen(false)}
          ticketId={createdTicketId}
          onSaved={() => {
            setCreateTicketOpen(false);
            setCreatedTicketId(null);
            fetchTickets();
          }}
        />
      )}

      {/* Menu de opções da Lane */}
      <Menu
        anchorEl={laneMenuAnchorEl}
        keepMounted
        open={Boolean(laneMenuAnchorEl)}
        onClose={closeLaneMenu}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {/* Mover esquerda/direita */}
        <MenuItem onClick={handleMoveLaneLeft} disabled={!laneMenuLane || tags.findIndex((t) => String(t.id) === String(laneMenuLane?.id)) <= 0}>
          <ChevronLeft style={{ fontSize: 18, marginRight: 8 }} /> Mover à esquerda
        </MenuItem>
        <MenuItem onClick={handleMoveLaneRight} disabled={!laneMenuLane || tags.findIndex((t) => String(t.id) === String(laneMenuLane?.id)) === tags.length - 1}>
          <ChevronRight style={{ fontSize: 18, marginRight: 8 }} /> Mover à direita
        </MenuItem>
        <MenuItem onClick={handleEditLane}>
          <EditOutlined style={{ fontSize: 18, marginRight: 8 }} /> Editar
        </MenuItem>
        <MenuItem onClick={handleConfirmDeleteLane}>
          <DeleteOutline style={{ fontSize: 18, marginRight: 8 }} /> Excluir
        </MenuItem>
      </Menu>

      {/* Confirmação de exclusão da Lane */}
      <ConfirmationModal
        title={`${i18n.t("tagsKanban.confirmationModal.deleteTitle")}`}
        open={confirmLaneOpen}
        onClose={setConfirmLaneOpen}
        onConfirm={handleDeleteLane}
      >
        {i18n.t("tagsKanban.confirmationModal.deleteMessage")}
      </ConfirmationModal>

      {/* Confirmação de envio de mensagem ao mover (modo prompt) */}
      <ConfirmationModal
        title="Enviar mensagem programada?"
        open={confirmGreeting.open}
  onClose={() => { setConfirmGreeting({ open: false, ticketId: null, targetLaneId: null, message: "" }); /* não enviar por padrão ao fechar */ }}
  onCancel={() => handleConfirmGreeting(false)}
        onConfirm={() => handleConfirmGreeting(true)}
        confirmText="Enviar"
        cancelText="Não enviar"
      >
        {confirmGreeting.message ? (
          <>
            <Typography variant="subtitle2" gutterBottom>Mensagem:</Typography>
            <Typography variant="body2" style={{ whiteSpace: 'pre-wrap' }}>{confirmGreeting.message}</Typography>
          </>
        ) : (
          "Deseja enviar a mensagem programada desta coluna ao mover o card?"
        )}
      </ConfirmationModal>

      {/* Modal de criação/edição de Lane */}
      {tagModalOpen && (
        <TagModal
          open={tagModalOpen}
          onClose={handleCloseTagModal}
          aria-labelledby="form-dialog-title"
          tagId={tagModalTagId}
          kanban={1}
        />
      )}

      {/* Modal de Configurações de SLA */}
      <Dialog open={slaModalOpen} onClose={() => setSlaModalOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Configurações de SLA</DialogTitle>
        <DialogContent>
          <Box display="grid" gridGap={12} style={{ gap: 12 }}>
            <TextField
              type="number"
              label="Tempo de SLA (min)"
              variant="outlined"
              size="small"
              value={slaDefaultMinutes}
              onChange={(e) => setSlaDefaultMinutes(Number(e.target.value))}
              fullWidth
              InputProps={{ inputProps: { min: 0 } }}
            />
            <TextField
              type="number"
              label="Avisar antes (min)"
              variant="outlined"
              size="small"
              value={slaWarnMinutes}
              onChange={(e) => setSlaWarnMinutes(Number(e.target.value))}
              fullWidth
              InputProps={{ inputProps: { min: 0 } }}
            />
            <FormControlLabel
              control={<Switch color="primary" checked={slaAutoDueDate} onChange={(e) => setSlaAutoDueDate(e.target.checked)} />}
              label="Preencher vencimento automaticamente"
            />
            <FormControlLabel
              control={<Switch color="primary" checked={slaNotifications} onChange={(e) => setSlaNotifications(e.target.checked)} />}
              label="Notificações de SLA"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSlaModalOpen(false)}>Cancelar</Button>
          <Button color="primary" variant="contained" disabled={slaLoading} onClick={async () => {
            try {
              setSlaLoading(true);
              const ops = [];
              ops.push(updateCompanySetting("slaDefaultMinutes", Number(slaDefaultMinutes) || 0));
              ops.push(updateCompanySetting("slaWarnMinutes", Number(slaWarnMinutes) || 0));
              ops.push(updateCompanySetting("slaAutoDueDate", slaAutoDueDate ? "enabled" : "disabled"));
              ops.push(updateCompanySetting("slaNotifications", slaNotifications ? "enabled" : "disabled"));
              await Promise.all(ops);
              toast.success("Configurações de SLA salvas");
              setSlaModalOpen(false);
            } catch (e) {
              toast.error("Não foi possível salvar o SLA");
            } finally {
              setSlaLoading(false);
            }
          }}>Salvar</Button>
        </DialogActions>
      </Dialog>

  {/* legacy quick-create dialog removed */}
    </div>
  );
};

export default Kanban;
